import { type ReactNode } from "react";
import { useLocation } from "react-router";

import { Box } from "@mui/material";

import {
  SearchFiltersAtom,
  dealerActiveAuctionSearchFiltersAtom
} from "@/src/state/dealer/dealerActiveAuctionSearchFiltersAtom";
import { openSearchFilterAtom } from "@/src/state/openSearchFilterAtom";
import { SortOrderAtomEnum } from "@/src/state/sortOrderAtom";

import SearchFilterButton from "@/src/pages/dealer/components/SearchFilterButton/SearchFilterButton";
import SortAuctionsButton from "@/src/pages/dealer/components/SortAuctionsButton/SortAuctionsButton";

import { PrimitiveAtom, useAtom } from "jotai";

export const countActiveFilters = (
  searchFilters?: SearchFiltersAtom
): number => {
  let count = 0;
  if (searchFilters?.distance && searchFilters.distance > 0) count++;
  if (searchFilters?.modelYear?.start || searchFilters?.modelYear?.end) count++;
  if (searchFilters?.mileage?.start || searchFilters?.mileage?.end) count++;
  if (searchFilters?.make && searchFilters.make.length > 0) count++;
  if (searchFilters?.fuelType && searchFilters.fuelType.length > 0) count++;
  if (searchFilters?.gearType && searchFilters.gearType.length > 0) count++;
  if (searchFilters?.bikeType && searchFilters.bikeType.length > 0) count++;
  if (searchFilters?.caravanSubtype && searchFilters.caravanSubtype.length > 0)
    count++;
  if (searchFilters?.targetPrice?.start || searchFilters?.targetPrice?.end)
    count++;
  return count;
};

export const areFiltersSet = (searchFilters?: SearchFiltersAtom): boolean =>
  countActiveFilters(searchFilters) > 0;

interface SearchFilterAndSortPanelProps {
  hideFilters?: boolean;
  sortOrderAtom: PrimitiveAtom<SortOrderAtomEnum>;
  leftSlot?: ReactNode;
}

const SearchFilterAndSortPanel = ({
  hideFilters,
  sortOrderAtom,
  leftSlot
}: SearchFilterAndSortPanelProps) => {
  const [openSearchFilter, setOpenSearchFilter] = useAtom(openSearchFilterAtom);
  const [searchFilters] = useAtom(dealerActiveAuctionSearchFiltersAtom);
  const location = useLocation();

  const isActiveAuctionsPage = location.pathname === "/dealer/all-active";

  return (
    <>
      {!isActiveAuctionsPage && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            mb: 2,
            gap: 2,
            flexDirection: ["column", "row"],
            width: "100%"
          }}
        >
          {leftSlot}
          {!hideFilters && (
            <SearchFilterButton
              isOpen={openSearchFilter}
              activeFilterCount={countActiveFilters(searchFilters)}
              onToggle={() => setOpenSearchFilter(!openSearchFilter)}
            />
          )}
          <SortAuctionsButton sortOrderAtom={sortOrderAtom} />
        </Box>
      )}
    </>
  );
};

export default SearchFilterAndSortPanel;
